  <div class="container-scroller">
  <app-header *ngIf="showHead"></app-header>
  <app-loader></app-loader>
   <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>